const noop = (..._props: unknown[]) => {
  //
};

export default noop;
